<template>
  <div class="app-tariffs-options-v2">
    <h2 class="text-3xl text-align-left">Services</h2>
    <div class="card">
      <img class="icon" src="/files/lidl/images/new-icons/svg/lock-filled.svg" alt=""/>
      <div style="display: flex">
        <h3 class="text-2xl">Anonyme Anrufe sperren (kostenlos)</h3>
        <div class="toggle-button">
          <label class="switch" for="toggle">
            <input @click="toogleBlocking" id="toggle" type="checkbox" name="block-calls" v-model="block">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div @click="showText = !showText" class="text-base bookable-services-accordion">Mehr Infos <img v-if="!showText" src="/files/lidl/images/new-icons/svg/angle-down-alt.svg" alt=""><img v-else src="/files/lidl/images/new-icons/angle-up-alt.svg" alt=""></div>
      <p class="text-base bookable-services-text" :class="showText ? 'd-block' : 'd-none'">Möchtest du keine anonymen Anrufe <abbr
        title="beziehungsweise">bzw.</abbr> mit unterdrückter Rufnummer erhalten, so kannst du die blockieren.
        Diese Sperre wird netzseitig gesetzt und kann nicht über dein <span lang="en">Smartphone</span> deaktiviert
        werden.
        Bitte beachte, die Einrichtung des Dienstes kann bis zur 1 Stunde dauern.
      </p>
    </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'
import joinTariffOptionsExtra from '@/helper/joinTariffOptionsExtras'
import transaction from '@/mixins/transaction'
import { mapActions } from 'vuex'

export default {
  name: 'ServiceOptions',
  components: {},
  data () {
    return {
      selectedOptions: [],
      serviceOptions: {
        tariffoptionId: ''
      },
      block: false,
      selectedOption: [],
      showText: false
    }
  },
  props: {
    extraData: {}
  },
  computed: {
    fullBookableServiceoptions: function () {
      const option = {
        ...this.serviceOptions,
        tariffoptionId: 'so_acr'
      }
      return [option].map(serviceOption => {
        return joinTariffOptionsExtra(serviceOption, this.extraData)
      })
    }
  },
  methods: {
    ...mapActions('serviceOptions', [
      'saveSelectedOptions',
      'saveDeactivateOptions'
    ]),
    toogleBlocking() {
      this.detailsBookableServiceAction()
      if (this.block) {
        this.saveSelectedOptions({
          option: this.fullBookableServiceoptions[0]
        })
      } else {
        this.saveDeactivateOptions({
          option: this.fullBookableServiceoptions[0]
        })
      }
    },
    detailsBookableServiceAction() {
      this.findSelectedOption('so_acr', this.fullBookableServiceoptions)
      this.block = this.fullBookableServiceoptions[0].anonymousCallRejection
    },
    findSelectedOption(option, optionList) {
      this.show = true
      this.selectedOption = optionList?.find(el => {
        return (el.tariffoptionId === option)
      })
    }
  },
  watch: {
    serviceOptions: {
      handler(newVal) {
        this.block = newVal.anonymousCallRejection
      },
      immediate: true,
      deep: true
    }
  },
  apollo: {
    tariffoptions: function () {
      return wrapQuery(
        gql`query tariffOptions {
           tariffoptions {
            bookableTariffoptions {
              bookableTariffoptions {
                bandwidth {
                down
                formattedUnit
                up
                unit
                }
                requiresContractSummary
                additionalInfo
                automaticExtension
                buttonText
                details
                formattedPrice
                name
                tariffoptionId
                name
                price
                duration {
                  amount
                  unit
                }
                notBookableWith
              }
            }
            bookedTariffoptions {
              bookedTariffoptions {
                bandwidth {
                  down
                  formattedUnit
                  up
                  unit
                }
                automaticExtension
                tariffoptionId
                name
                price
                duration {
                  amount
                  unit
                }
                statusKey
                startOfRuntime
                endOfRuntime
                possibleChangingDate
                buttonText
                cancelable
                formattedPrice
                restrictedService
                tariffState
              }
            }
           }
        }`, this, 'tariffoptions'
      )
    },
    serviceOptions: function () {
      return wrapQuery(
        gql`query serviceOptions {
          serviceOptions {
            anonymousCallRejection
          }
        }`, this, 'serviceOptions'
      )
    }
  },
  mixins: [
    slotProxy(),
    transaction('tariffOptions'),
    transaction('serviceOptions')
  ]
}
</script>
